import * as Core from './../core';

export abstract class SearchService {
    public static async search(query: string): Promise<Core.Models.SearchResult[]> {
        const route = Core.API.ServerRoute.forAction('search', `?query=${encodeURIComponent(query)}`);
        return await Core.API.get(route);
    }
}
